const header = document.querySelector('.header');
const breakpoint = window.matchMedia('(max-width: 1023px)');
let screenHeight = document.documentElement.clientHeight;

const breakpointChecker = () => {
  if (breakpoint.matches) {
    // mobile
    screenHeight = document.documentElement.clientHeight;
  }
};

const onWindowScroll = () => {
  if (document.documentElement.scrollTop > screenHeight) {
    header.classList.remove('is-hidden');
    header.classList.add('is-shown');
    header.classList.add('navigation-changer');
    header.classList.add('fixed');
  } else if (document.documentElement.scrollTop > screenHeight / 2) {
    header.classList.add('is-hidden');
    header.classList.remove('is-shown');
    header.classList.remove('navigation-changer');
  } else if (!document.body.dataset.scroll) {
    header.classList.remove('is-hidden');
    header.classList.remove('fixed');
  }
};

const initHeader = () => {
  if (header && header.querySelector('.main-nav')) {
    breakpoint.addListener(breakpointChecker);
    window.addEventListener('scroll', onWindowScroll);
  }
};

export {initHeader};
